export const CHANGE_CURRENT_PAGE = 'stripeSettings/CHANGE_CURRENT_PAGE'
export const CHANGE_PAGE_SIZE = 'stripeSettings/CHANGE_PAGE_SIZE'
export const CREATE_STRIPE_SETTING = 'stripeSettings/CREATE_STRIPE_SETTING'
export const FETCH_STRIPE_SETTINGS_LIST = 'stripeSettings/FETCH_STRIPE_SETTINGS_LIST'
export const FETCH_STRIPE_SETTINGS_FOR_OPTIONS = 'stripeSettings/FETCH_STRIPE_SETTINGS_FOR_OPTIONS'
export const REMOVE_STRIPE_SETTING = 'stripeSettings/REMOVE_STRIPE_SETTING'
export const UPDATE_STRIPE_SETTING = 'stripeSettings/UPDATE_STRIPE_SETTING'
